const updateQuantity = (increment) => {
    $(document).on('click', increment ? '.product-quantity-up' : '.product-quantity-down', function (e) {
        e.preventDefault();
        const fieldName = $(this).data('field-qty');
        let currentVal = parseInt($('input.' + fieldName).val());
        if (!isNaN(currentVal)) {
            currentVal = increment ? currentVal + 1 : Math.max(currentVal - 1, 1);
            $('input.' + fieldName).val(currentVal).trigger('keyup');
        } else {
            $('input.' + fieldName).val(1);
        }
    });
}

const Quantity = () => {
    updateQuantity(true);
    updateQuantity(false);
}

export default Quantity;